<ion-content class="modal-content">
  <div class="modal-container w-full p-4">
    <ion-icon name="finger-print" class="modal-icon"></ion-icon>
    <h2 class="title-modal">{{ 'login.biometric.header-modal' | translate }}</h2>
    <p class="message-modal">{{ 'login.biometric.message-modal' | translate }}</p>
    <div class="flex flex-wrap gap-2 justify-center py-4">
      <ion-button expand="block" class="btn-cancel" color="medium" (click)="closeModal()">{{ 'login.biometric.cancel' | translate }}</ion-button>
      <ion-button expand="block" class="btn-config btn-expand" (click)="enableBiometrics()">{{ 'login.biometric.enable' | translate }}</ion-button>
    </div>
  </div>
</ion-content>
